import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { ResultBase } from '../base';
import i18n from './messages';
import magnifyingGlass from 'assets/images/search-modal-magnifying-glass.svg';

interface SearchResultNoneProps {
    className?: string;
}

const SearchResultNone: React.StatelessComponent<SearchResultNoneProps> = (props) => {
    return (
        <ResultBase
            {...props}
            imageSrc={magnifyingGlass}
            title={<FormattedMessage {...i18n.noSearchResultTitle} />}
            helperText={<FormattedMessage {...i18n.noSearchResultText} />}
        />
    );
};

export default SearchResultNone;
